// extracted by mini-css-extract-plugin
export var infoItem = "_jx-1";
export var title = "_jx-0";